import HistoryBoxList from "./history_list";
import { Grid, Typography } from "@mui/material";
import { useEffect, useState } from 'react';
import Filter from "./filter";
import { findOrdersEvent } from "../../../_events/orders/find_order.event";
import { message } from "antd";
import { format, parseISO } from 'date-fns';

const HistoryBox = () => {

  const [process, setProcess] = useState(false);
  const [orders, setOrders] = useState(false);
  

  //variables of filter
  const [dateStartFilter, setDateStartFilter] = useState(false);
  const [dateEndFilter, setDateEndFilter] = useState(false);
  const [idOrderFilter, setIdOrderFilter] = useState(false);
  const [clientFilter, setClientFilter] = useState(false);
  const [colorFilter, setColorFilter] = useState(false);
  const [ordersFilter, setOrdersFilter] = useState(false);
  const [processFilter, setProcessFilter] = useState(false);
  
  const loadOrders = () => {
    findOrdersEvent('HIST')
    .then(data => {
      let orders_list = [];
      let process_list = [];
      data.list.forEach(obj => {  
        if (obj.uuid) {  
          orders_list.push(obj);
        }
        if(obj.cod && obj.cod !== 'ALIS' )
        {
          process_list.push(obj)
        }
      });
      setOrders(orders_list);
      setProcess(process_list);
    })
    .catch(err => {
      message.error(err.message);
    });
  }

  //methods of filter
  const filterOrders = () => {
    const filteredOrders = orders
      ? orders.filter((order) => {
          const idFilter = idOrderFilter ? order.id.toString().toLowerCase().includes(idOrderFilter.toLowerCase()) : true;
          
          const dateStartFilterResult = dateStartFilter ? order.date_created ? format(parseISO(order.date_created), 'dd-MM-yyyy').includes(format(parseISO(dateStartFilter), 'dd-MM-yyyy')) : null
          : true;

          const dateEndFilterResult = dateEndFilter ? order.date_delivery? format(parseISO(order.date_delivery), 'dd-MM-yyyy').includes(format(parseISO(dateEndFilter), 'dd-MM-yyyy')) : null
          : true;
          
          const clientFilterResult = clientFilter
            ? order.ordersDetail?.some((od) => od.productPrice.client.name.toString().toLowerCase().includes(clientFilter.toLowerCase()))
            : true;

          const colorFilterResult = colorFilter
            ? order.ordersDetail?.some((od) => od.color?.cod.toString().toLowerCase().includes(colorFilter.toLowerCase()))
            : true;
          
          const processFilterResult = processFilter
            ? order.ordersDetail?.some((od) => od.cod_process.toString().toLowerCase().includes(processFilter.toLowerCase()))
            : true;
          
          return idFilter && clientFilterResult && dateStartFilterResult && colorFilterResult && processFilterResult && dateEndFilterResult;
        })
      : [];
    
    setOrdersFilter(filteredOrders);
  };

  const cleanFilterOrders = () => {
    setOrdersFilter(false);
  }

  useEffect(() => {
    loadOrders();
  }, []);

  return(
    <Grid container spacing={1} >
      <Grid item xs={12} md={12}>
          <Typography variant="h6" component="h6" >
              Bandeja de seguimiento
          </Typography>
      </Grid>
      <Grid item xs={12} md={12}>
        <hr/>
        
        <Filter
          process={process}
          setDateStartFilter={(dateStart)=>setDateStartFilter(dateStart)}
          setIdOrderFilter={(idOrder)=>setIdOrderFilter(idOrder)}
          setClientFilter={(client)=>setClientFilter(client)}
          setColorFilter={(color)=>setColorFilter(color)}
          setDateEndFilter={(dataEnd)=>setDateEndFilter(dataEnd)}
          setProcessFilter={(codProcess)=>setProcessFilter(codProcess)} 
          filterOrders={filterOrders}
          cleanFilterOrders={cleanFilterOrders}
        />


        <HistoryBoxList
          orders={ordersFilter ? ordersFilter: orders}
        />
           
      </Grid>
    </Grid>
  );
  
}

export default HistoryBox;
